// extracted by mini-css-extract-plugin
export var searchHeader = "_8y-0";
export var searchHeaderDark = "_8y-1";